import React from 'react';
import { NavLink } from 'react-router-dom';
import './platform.css';

const IcoGrid = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
    <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
  </svg>
);

const IcoHome = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 9l9-6 9 6v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);

const PRODUCT_META = {
  core:     { label: '3AImigos',          to: '/app/core',     Icon: IcoGrid,  cls: 'product-tab--core' },
  re_suite: { label: 'Real Estate Suite', to: '/app/re-suite', Icon: IcoHome,  cls: 'product-tab--re'   },
};

export default function ProductTabBar({ products }) {
  return (
    <nav className="product-tab-bar" role="tablist" aria-label="Product switcher">
      {products.map(id => {
        const { label, to, Icon, cls } = PRODUCT_META[id] || {};
        if (!label) return null;
        return (
          <NavLink
            key={id}
            to={to}
            className={({ isActive }) =>
              `product-tab ${cls}${isActive ? ' product-tab--active' : ''}`
            }
            role="tab"
          >
            <span className="product-tab-ico"><Icon /></span>
            {label}
          </NavLink>
        );
      })}
    </nav>
  );
}
